import Image from 'next/image';
import { Skeleton } from '@savvy-kit/components/skeleton';
import { SavvyLogo } from '@savvy-kit/foundations/savvy-logo';

import { isPresentString } from './utils';

type ClientPortalBrandHeaderProps = {
  readonly firmName: string | null;
  readonly firmLogoUrl: string | null;
  readonly isLoading: boolean;
};

export function ClientPortalBrandHeader({ firmName, firmLogoUrl, isLoading }: ClientPortalBrandHeaderProps) {
  if (isLoading) {
    return <Skeleton className="h-5 w-32" />;
  }

  if (isPresentString(firmLogoUrl)) {
    return (
      <div className="relative h-10 w-44">
        <Image
          src={firmLogoUrl}
          alt={firmName ?? 'Your firm'}
          fill
          className="object-contain object-left"
          unoptimized
        />
      </div>
    );
  }

  if (isPresentString(firmName)) {
    return <span className="truncate font-display text-sm leading-none text-foreground">{firmName}</span>;
  }

  return <SavvyLogo />;
}
